import React from 'react'
import {Button, Container, Image, Row} from 'react-bootstrap'
import {
  ROOT_URL,
  FACEBOOK_URL,
  YOUTUBE_URL
} from '../../constants/urls'
import {
  ICON_YOUTUBE_COLOR,
  ICON_FB_COLOR,
} from '../../constants/svgs'
import {useNavigate} from 'react-router'
import {localise} from '../../services/LocalizationServices'
import {Link} from 'react-router-dom'
import {CONTACT_EMAIL} from '../../constants/env'
import {Helmet} from 'react-helmet'

const ContactMe = () => {
  const history = useNavigate()
  const toFacebook = () => {window.open(FACEBOOK_URL)}
  const toYoutube = () => {window.open(YOUTUBE_URL)}

  const SocialImg = ({img, alt, onClick}) => (
    <Image className='cursor-pointer me-3 social-icon' src={img} width={48} height={48} alt={alt} onClick={onClick}/>
  )

  return (
    <div>
      <Helmet>
        <meta charSet='utf-8' name='description' content={localise('SEO.contactMe.description')}/>
        <meta charSet='utf-8' name='keywords' content={localise('SEO.contactMe.keywords')}/>
        <title>{localise('SEO.contactMe.title')}</title>
      </Helmet>
      <Container className='padding-under-nav'>
        <div>
          <div className='header-section mb-3'>
            {localise('contactMe.title')}
          </div>
          <div className='d-flex justify-content-center'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href={ROOT_URL}>{localise('nav.home')}</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {localise('nav.contact')}
                </li>
              </ol>
            </nav>
          </div>
          {/* <div className='homepage-about-title text-center mt-5'>
            {localise('contactMe.tagline')}
          </div>
          <div>
            <div className='about-Subheader text-center mt-4'>
              {localise('contactMe.header')}
            </div>
          </div>
          <div className='w-100 my-4'>
            <div className='about-normal text-center'>
              {localise('services.introDesc')}
            </div>
          </div> */}
        </div>
        <div className='w-100'>
          <div className='my-4'>
            <div className="contact-me-cards">
              <div className='col text-align-start w-100'>
                <div className='item-title mb-1'>{localise('contactMe.addressTitle')}</div>
                <div className='item-desc'>{localise('contactMe.address')}</div>
              </div>
              <div className='col text-align-start w-100'>
                <div className='item-title mb-1'>{localise('contactMe.phone')}</div>
                <Link className='text-decoration-none item-desc' to={''} onClick={e => {
                  window.location = 'tel:0857125814'
                  e.preventDefault()
                }}>
                  {localise('contactMe.phoneNum')}
                </Link>
              </div>
              <div className='col text-align-start w-100'>
                <div className='item-title mb-1'>{localise('contactMe.email')}</div>
                <Link className='text-decoration-none custom-link item-desc' to={''} onClick={e => {
                  window.location = `mailto:${CONTACT_EMAIL}`
                  e.preventDefault()
                }}>
                  {CONTACT_EMAIL}
                </Link>
              </div>
              <div className='col text-align-start w-100'>
                <div className='item-title mb-1'>{localise('contactMe.followMe')}</div>
                <div className='item-icons'>
                  <SocialImg img={ICON_FB_COLOR} alt='facebook' onClick={toFacebook}/>
                  <Image className='cursor-pointer social-icon' src={ICON_YOUTUBE_COLOR} width={48} height={48} alt={'youtube'} onClick={toYoutube}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <iframe 
        className='mt-5'
        width="100%" 
        height="300" 
        frameborder="0" 
        marginheight="0" 
        marginwidth="0" 
        src="https://maps.google.com/maps?width=100%25&amp;height=300&amp;hl=en&amp;q=Arklow,%20Co.wicklow+(The%20Hypnotherapy%20Practice)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
          <a href="https://www.mapsdirections.info/it/calcola-la-popolazione-su-una-mappa/"></a>
      </iframe>
    </div>
  )
}

export default ContactMe